// freshness.js — shared data-staleness windows for the Kai paths.
//
// One source of truth so the same figure cannot be treated as fresh in one Kai
// path and stale in another on the same morning. src/lib is imported directly
// by the client (Scorify.jsx) AND by the server (api/lib/coach-run.js), the
// same convention as screenTimeUsage.js and bills.js — pure ESM, no JSX, so the
// two surfaces cannot disagree about the threshold.

// Bank balances / Plaid cache older than this are not vouchable as current.
// 12h, the stricter of the two windows that used to diverge (client nulled the
// balance at 12h while the cron only labeled it "as of" past 24h, so a 15h-old
// balance read "unknown" in chat/briefing yet was quoted plainly by the cron).
// 12h still quotes any balance refreshed since the user's last app session the
// same day, so it does not hide genuinely fresh data.
export const BALANCE_FRESH_WINDOW_MS = 12 * 60 * 60 * 1000;
